module.exports = __webpack_public_path__ + "img/cancel_black_24dp (1)WW.ceb21215.svg";